var map = {
	"./DNS.png": "b56d",
	"./cloudServiceSolid.png": "36e4",
	"./cloudmigrate.png": "e431",
	"./devOps.png": "97e1",
	"./didbanSolid.png": "8f91",
	"./help.png": "44fd",
	"./high-sell.png": "2f07",
	"./left-arrow.png": "76fc",
	"./mailSolid.png": "60a4",
	"./package.png": "ffff1",
	"./public-relation.png": "7a5a",
	"./seo.png": "ce90",
	"./servers.png": "8afd",
	"./sys.png": "22c3",
	"./ubunto.png": "ea69",
	"./viraCloudSolid.png": "5457",
	"./wordpress-logo.png": "d85e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b874";